import type { SshStatus } from "../types";

const STATUS_CLASSES: Record<SshStatus, string> = {
  connected: "bg-green-500 shadow-[0_0_6px_#16a34a]",
  connecting: "bg-amber-500 animate-pulse",
  reconnecting: "bg-orange-500 animate-pulse",
  error: "bg-red-500",
  disconnected: "bg-slate-400",
};

export function StatusDot({ status }: { status: SshStatus }) {
  return (
    <span className={`inline-block w-2 h-2 rounded-full shrink-0 ${STATUS_CLASSES[status]}`} />
  );
}
